const contacts = [
  {
    title: 'Prodaja',
    contacts: [
      {
        name: 'Džanan Drobić, dipl. ing.',
        phone: '+385 (0) 1 2498-982',
        fax: '+385 (0) 1 2406-237',
        email: 'dzanan.drobic@iskraemeco.hr',
      },
    ],
  },
  {
    title: 'Računovodstvo',
    contacts: [
      {
        name: 'Katica Mustapić, dipl. oec.',
        phone: '+385 (0) 1 2498-986',
        fax: '+385 (0) 1 2498-981',
        email: 'financije@iskraemeco.hr',
      },
      {
        name: 'Višnja Kršić',
        phone: '+385 (0) 1 2498-985',
        email: 'visnja.krsic@iskraemeco.hr',
      },
    ],
  },
  {
    title: 'Podrška brojila',
    contacts: [
      {
        name: 'Ante Bračić',
        phone: '+385 (0) 1 2498-991',
        email: 'ante.bracic@iskraemeco.hr',
      },
    ],
  },
  {
    title: 'Automatizacija',
    contacts: [
      {
        name: 'Marijan Metikoš, dipl. ing.',
        phone: '+385 (0) 1 2498-992',
        email: 'marijan.metikos@iskraemeco.hr',
      },
    ],
  },
  {
    title: 'Proizvodnja i laboratorij',
    contacts: [
      {
        name: 'Zvonimir Harapin, ing. el.',
        phone: '+385 (0) 1 2498-999',
        email: 'zvonimir.harapin@iskraemeco.hr',
      },
    ],
  },
]

export default contacts



// WEBPACK FOOTER //
// ./src/contacts.js